import React, {Component} from 'react';
import PropTypes from 'prop-types'
import { DragSource } from 'react-dnd'
import {ItemTypes} from "./ItemsTypes";
import {getEmptyImage} from "react-dnd-html5-backend";

const sleeveSource = {
    beginDrag(props) {
        return {
            background: props.background,
            currentStep: props.currentStep,
            index: props.index,
            isSleeveOnPlan: props.isSleeveOnPlan
        }
    }
};

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    }
}

class SleeveDropSource extends Component {
    componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview(getEmptyImage(), {
            // IE fallback: specify that we'd rather screenshot the node
            // when it already knows it's being dragged so we can hide it with CSS.
            captureDraggingState: true,
        })
    }
    render(){
        const deleteSleeve = () => {
            if(this.props.index>=0 && this.props.deleteSleeve){
                this.props.deleteSleeve({
                    index: this.props.index,
                    side : this.props.currentStep - 2
                });
            }
        };

        if(this.props.withoutDragging){
            return (
                <span className="sleeves-item-icon"
                      id = {this.props.id}
                      style = {{...this.props.styleForSleeveIcon, ...this.props.styles}}>
                    <span>&#x2717;</span>
                </span>
            )
        }

        return this.props.connectDragSource(
            <span className="sleeves-item-icon"
                  id = {this.props.id}
                  onClick = {deleteSleeve}
                  style = {{...this.props.styleForSleeveIcon, ...this.props.styles}}>
                <span>&#x2717;</span>
            </span>
        )
    }
}

/*** props types for SleeveDropSource
 *
 * ***/
SleeveDropSource.propTypes = {
    styleForSleeveIcon : PropTypes.object,
    background : PropTypes.string,
    currentStep : PropTypes.number,
    styles : PropTypes.shape({
        top : PropTypes.string,
        left : PropTypes.string,
        background : PropTypes.string,
    }),
    index : PropTypes.number

};


export default DragSource(ItemTypes.CELL, sleeveSource, collect)(SleeveDropSource)




// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/BuildsComponent/SleeveDragSource.js